export default {
  UPDATE_REFERRED_CODES_CLUBS: "UPDATE_REFERRED_CODES_CLUBS",
  UPDATE_REFERRED_CODES_MAINTENANCES: "UPDATE_REFERRED_CODES_MAINTENANCES",
  GET_REFERRED_CODES_CLUBS: "GET_REFERRED_CODES_CLUBS",
  GET_REFERRED_CODES_MAINTENANCES: "GET_REFERRED_CODES_MAINTENANCES"
};
